module.exports = __webpack_public_path__ + "img/BE0882414641.79c1ee44.png";